import { useCallback, useEffect, useState } from 'react';
import MKBox from 'components/MaterialKit/MKBox';
import EditAppForm from 'pages/AppSummary/EditAppForm';
import { handleErrorResponse } from 'utils/general';
import { getCollectionDefinition } from 'api/collection_definitions';
import { getDynamicTableRows } from 'api/sections';
import { getDynamicData } from 'utils/sections';
import { useAuth } from 'contexts/auth';
import MKTypography from 'components/MaterialKit/MKTypography';
import DataTable from 'components/DataTable';
import { useNavigate, useParams } from 'react-router-dom';
import GoogleTranslateButtonSection from 'sections/GoogleTranslateButton';

export const LANGUAGE_COLLECTION_DEFINITION_ID = '73c6d4a4-4014-4df9-9f9a-f82902418eef';

const languageTableColumn = [
  {
    field: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    field: 'google_label',
    label: 'Google Label',
    sortable: true,
  },
  {
    field: 'value',
    label: 'Value',
    sortable: true,
  },
  {
    field: 'priority',
    label: 'Priority',
    sortable: true,
  },
]

const LanguageSection = () => {
  const { setAuth } = useAuth();
  const [languageData, setLanguageData] = useState([]);
  const navigate = useNavigate();
  const { appId } = useParams();

  const fetchCollectionDefinitionFromApi = useCallback(() => {
    const collectionDefinitionParams = {
      $expand: 'attributes',
    };
    return getCollectionDefinition(LANGUAGE_COLLECTION_DEFINITION_ID, collectionDefinitionParams)
      .then((res) => {
        const collectionDefinition = res.data;
        const { attributes } = collectionDefinition;
        return getDynamicTableRows(LANGUAGE_COLLECTION_DEFINITION_ID)
          .then(({ data }) => {
            const dynamicFieldValueData = data.map((datum) => ({
              ...getDynamicData(datum, attributes),
              ...datum,
            }));
            setLanguageData(dynamicFieldValueData);
          })
          .catch((err) => {
            handleErrorResponse(err, setAuth);
          });
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      });
  }, [setAuth]);

  useEffect(() => {
    fetchCollectionDefinitionFromApi();
  }, [fetchCollectionDefinitionFromApi]);

  const onPressEdit = useCallback((languageId) => {
    navigate(`/app/${appId}/language/${languageId}`);
  }, [appId, navigate]);

  const onPressAdd = useCallback(() => {
    navigate(`/app/${appId}/language/`);
  }, [appId, navigate]);

  return (
    <MKBox mt={3}>
      <MKBox display="flex" justifyContent="space-between" alignItems="center" p={1}>
        <MKTypography variant="h6">Languages</MKTypography>
      </MKBox>
      <DataTable
        data={languageData}
        columns={languageTableColumn}
        idField="id"
        onPressEdit={onPressEdit}
        onPressAdd={onPressAdd}
        paginationDisabled
        selectable
      />
      <MKBox mt={2}>
        <GoogleTranslateButtonSection />
      </MKBox>
    </MKBox>
  );
};

export default LanguageSection;
